




































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import UpdateLocationWorkerRequest from "@/models/LocationWorkers/UpdateLocationWorkerRequest";
import ListUtils from "@/lib/listUtils";
import LocationWorkerDto from "@/models/LocationWorkers/LocationWorkerDto";
import { WorkerDetailsModule } from "@/store/modules/workerDetails";
@Component({
  name: "WorkerLocationEdit",
})
export default class extends GiganautVueDialog {

  public request = new UpdateLocationWorkerRequest();

  @Prop({ required: true })
  workerLocation: LocationWorkerDto;

  @Watch("dialog")
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.request = new UpdateLocationWorkerRequest();
      this.request.type = this.workerLocation.type;
    }
  }

  get loading() {
    return WorkerDetailsModule.loadingDialog;
  }

  get types() {
    return ListUtils.locationWorkerTypes();
  }

  async save() {
    this.request.locationWorkerId = this.workerLocation.id;
    this.request.locationId = this.workerLocation.locationId;
    this.request.updatedAt = this.workerLocation.updatedAt;
    await WorkerDetailsModule.updateLocationWorker(this.request);
    this.dialog = false;
  }
}
